import styled, { css } from 'styled-components';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
import { fontRegular16, fontSemibold16 } from '../styles/fonts';
export const BalanceContainer = styled.div `
  ${fontRegular16}
  margin: 14px 10px 0;
  padding: 16px;
  box-shadow: 0px 1px 4px rgb(182 182 182 / 50%);
  border-radius: 4px;

  @media (min-width: ${breakpointLG}) {
    display: flex;
    width: max-content;
    padding: 12px 22px;
    margin: 8px 0 0 auto;
    margin-left: auto;
  }
`;
export const BalanceItem = styled.div `
  display: flex;
  justify-content: space-between;

  &:last-child {
    margin: 8px 0 0;
  }

  @media (min-width: ${breakpointLG}) {
    display: flex;
    gap: 4px;

    &:last-child {
      margin: 0 0 0 20px;
    }
  }
`;
export const negativeAmount = css `
  padding: 2px 4px;
  color: ${Colors.error100};
  background-color: ${Colors.error10};
`;
export const AmountLabel = styled('span')(({ $isNegative }) => (Object.assign(Object.assign({}, fontSemibold16), ($isNegative && negativeAmount))));
//# sourceMappingURL=styles.js.map